/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a style={{color:'#333', textTransform:"none"}} href="https://www.sebsa.com.br" className={classes.block}>
              &copy; {1900 + new Date().getYear()}{" "} Grupo SEB. Todos os direitos reservados.
              </a>
            </ListItem>
          </List>
        </div>

      </div>
    </footer>
  );
}
